import colors from 'shared-tokens/utils/tokens/colors';
import tp from 'shared-tokens/utils/tokens/typography';
import createBreakpoint from 'shared-tokens/utils/breakpoints';
import getExtPath from 'shared-utils/src/getExtPath';

const brpS = createBreakpoint('s');
const brpM = createBreakpoint('m');
const brpL = createBreakpoint('l');

export const mainCls = 'csa_nav';
export default {
  [mainCls]: {
    position: 'absolute',
    top: 0,
    left: 0,    
    width: '100vw',
    minHeight: '100vh',
    background: colors.secondary.rgba,
    zIndex: 11,
    transform: 'translate(-100%, 0)',
    transition: 'transform 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22)',
    '& ul': {
      listStyleType: 'none',
    },
    [brpS]: {
      width: '50%',
    },
    [brpM]: {
      width: '33%',
    },
    [brpL]: {
      top: 8,
      left: 65,
      padding: '0!important',
      width: 0,
      height: 'auto',
      minHeight: 'initial',
      background: 'transparent',
      transform: 'translate(0, 0)',
      transition: 'width 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22)',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  },
  [`${mainCls}--opn`]: {
    transform: 'translate(0, 0)',
    [brpL]: {      
      width: '494px',
    },
  },
  [`${mainCls}__head--cls`]: {
    position: 'absolute',
    top: 16,
    right: 16,
    padding: 0,
    width: 18,
    height: 18,
    background: 'transparent',
    border: '0 none',
    zIndex: 1,
    [brpL]: {
      display: 'none',
    },    
  },
  [`${mainCls}__scrl`]: {
    paddingTop: 34,
    width: '100%',
    maxHeight: 'var(--window-inner-height)',
    overflow: 'auto',
    [brpM]: {
      maxHeight: '100%',
    },
    [brpL]: {
      padding: '0 !important',
      overflow: 'hidden',
    },
  },
  [`${mainCls}__scrl-ctn`]: {
    position: 'relative',
    width: '100%',
    minHeight: 'var(--window-inner-height)',
    [brpS]: {
      minHeight: 'calc(var(--window-inner-height) - 34px)',
    },
    [brpL]: {
      minHeight: 'initial',
    },
  },
  [`${mainCls}__ul`]: {
    [brpL]: {
      display: 'flex',
    },
  },
  [`${mainCls}__li`]: {
    lineHeight: '48px',
    [brpL]: {
      marginLeft: 10,
      lineHeight: '44px',
    },
    '@media screen and (min-width: 1070px)': {
      marginLeft: 20,
    },
  },
  [`${mainCls}__li--mob`]: {
    [brpL]: {
      display: 'none',
    },
  },
  [`${mainCls}__li--dsk`]: {
    display: 'none',
    [brpL]: {
      display: 'block',
    },
  },
  [`${mainCls}__li--nomar`]: {
    [brpL]: {
      marginLeft: 0,
      lineHeight: '44px',
    },
  },
  [`${mainCls}__li--new`]: {
    display: 'flex',
    alignItems: 'center',
    '&::after': {
      content: '"Novità"',
      marginLeft: 10,
      padding: '1px 5px 0',
      height: 16,
      fontSize: 11,
      lineHeight: '16px',
      fontFamily: tp.tpFonts.m,
      color: colors.w.rgba,
      background: '#ff8000',
      borderRadius: 2,
    },
    [brpL]: {
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 12,
        right: '-6px',
        margin: 0,
        padding: 0,
        width: 5,
        height: 5,
        background: '#ff9a2a',
        borderRadius: '50%',
      },
    },
  },
  [`${mainCls}__lnk`]: {
    fontSize: 18,
    color: colors.w.rgba,
    [brpL]: {
      position: 'relative',
      display: 'block',
      fontSize: tp.tpSizes.s,
      lineHeight: 'inherit',
      color: colors.secondary.rgba,
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '100%',
        left: 0,
        width: '100%',
        height: 2,
        background: colors.secondary.rgba,
        opacity: 0,
        transition: 'opacity .3s,transform .3s,-webkit-transform .3s',
      },
      '&:hover': {
        '&::after': {
          opacity: '.9',
          transform: 'translateY(-9px)',
        },
      },
    },
  },
  [`${mainCls}__lnk--tras`]: {
    [brpL]: {
      color: colors.w.rgba,
      '&::after': {
        background: colors.w.rgba,
      }
    },
  },
  [`${mainCls}__bapp`]: {
    padding: '24px 0',
    marginTop: 13,
    borderTop: 'solid 1px #697684',
    borderBottom: 'solid 1px #697684',
    [brpL]: {
      display: 'none',
    },
  },
  [`${mainCls}__bapp-p`]: {
    margin: '-2px 0 5px',
  },
  [`${mainCls}__bapp-lg`]: {
    marginRight: 12,
    width: 40,
    height: 40,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '29px 29px',
    borderRadius: 10,
  },
  [`${mainCls}__bapp-stars`]: {
    display: 'flex',
  },
  [`${mainCls}__bapp-star`]: {
    width: 18,
    height: 18,
    background: `url(${getExtPath('common_images/common/star-blur.png')}) 0 0 no-repeat`,
    backgroundSize: '17px 17px',
  },
  [`${mainCls}__bapp-ios`]: {
    display: 'block',
    width: 120,
    height: 40,
    backgroundPosition: '0 0',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '120px auto',
    textIndent: '-9999em',
  },
  [`${mainCls}__bapp-and`]: {
    display: 'block',
    width: 136,
    height: 40,
    backgroundColor: 'transparent', 
    backgroundPosition: '0 0',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '136px auto',
    border: '0 none',
    textIndent: '-9999em',
  },
  [`${mainCls}__bapp-huw`]: {
    display: 'block',
    width: 134,
    height: 40,
    backgroundPosition: '0 0',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '134px auto',
    textIndent: '-9999em',
  },    
  [`${mainCls}__share`]: {
    display: 'flex',
    padding: '31px 0 120px',
    '& a': {
      display: 'block',
      marginRight: 12,
      width: 40,
      height: 40,
      textIndent: '-9999em',
    },
    [brpL]: {
      display: 'none',
    },
  },
  [`${mainCls}__logo`]: {
    display: 'block',
    position: 'absolute',
    bottom: 32,
    left: 0,
    width: 230,
    height: 46,
    textIndent: '-9999em',
    [brpL]: {
      display: 'none',
    },
  },
  [`${mainCls}--wImgs`]: {
    [`& .${mainCls}__bapp-lg`]: {
      backgroundImage: `url(${getExtPath('common_images/common/solologo.svg')})`,
    },
    [`& .${mainCls}__bapp-ios`]: {
      backgroundImage: `url(${getExtPath('common_images/common/app-store.svg')})`,
    },
    [`& .${mainCls}__bapp-and`]: {
      backgroundImage: `url(${getExtPath('common_images/common/google-play.svg')})`,
    },
    [`& .${mainCls}__bapp-huw`]: {
      backgroundImage: `url(${getExtPath('common_images/common/huawei-store.svg')})`,
    },
    [`& .${mainCls}__share`]: {
      '& a': {
        backgroundSize: '40px 40px !important',
        '&.fb': {
          background: `url(${getExtPath('common_images/footer/new/facebook.svg')}) 0 0 no-repeat`,
        },
        '&.tw': {
          background: `url(${getExtPath('common_images/footer/new/x.svg')}) 0 0 no-repeat`,
        },
        '&.yt': {
          background: `url(${getExtPath('common_images/footer/new/youtube.svg')}) 0 0 no-repeat`,
        },
        '&.in': {
          background: `url(${getExtPath('common_images/footer/new/linkedin.svg')}) 0 0 no-repeat`,
        },
        '&.is': {
          background: `url(${getExtPath('common_images/footer/new/instagram.svg')}) 0 0 no-repeat`,
        },
        '&.tg': {
          background: `url(${getExtPath('common_images/footer/new/telegram.svg')}) 0 0 no-repeat`,
        },
      },
    },
    [`& .${mainCls}__logo`]: {
      background: `url(${getExtPath('common_images/footer/logoWhite2024.svg')}) 0 0 no-repeat`,
      backgroundSize: '230px auto',
    }
  },
  [`${mainCls}--fix`]: {
    position: 'fixed',
    [brpL]: {
      transition: 'top .3s linear, width 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22)',
    },
  },
  [`${mainCls}--hid`]: {
    [brpL]: {
      top: '-54px',
    },
  },  
  [`${mainCls}__ovrl`]: {
    position: 'fixed',
    top: 0,
    left: 0,
    background: '#000',
    opacity: 0,
    transition: 'opacity .3s linear',
    zIndex: 10,
    [brpL]: {
      display: 'none',
    }
  },
  [`${mainCls}__ovrl--opn`]: {
    right: 0,
    bottom: 0,
    opacity: '.3',
  },
};